import { Component, OnInit, AfterViewInit } from '@angular/core';

@Component({
  selector: '[mft-footer]',
  templateUrl: './footer.component.html'
})
export class FooterComponent implements OnInit, AfterViewInit {  
  constructor() {

  }

  ngOnInit() {
    
  }

  ngAfterViewInit() {
    
  }

  onWelcomeLoginClick(event): void {
    
  }
}



// WEBPACK FOOTER //
// ./src/app/headerandnavigation/footer/footer.component.ts